import { type ToastContainerProps } from 'react-toastify';

export const toastContainerProps: ToastContainerProps = {
  hideProgressBar: true,
  closeOnClick: true,
  newestOnTop: true,
  pauseOnFocusLoss: true,
  pauseOnHover: true,
  rtl: false,
  draggable: false,
  theme: 'light',
  position: 'bottom-right',
  autoClose: 3000,
  toastStyle: {
    borderRadius: '1rem',
    padding: '0.6rem',
    paddingRight: '0.8rem',
  },
};
